module.exports = __webpack_public_path__ + "img/20200613_092859.1f2d5fcb.jpg";